const cartItems = document.querySelector(".cart-items");
const cartItem = document.querySelector(".cart-item");
const cartIcon = document.querySelector(".Cart-button");
let cartCount = cartIcon.getAttribute("data-cart-number");
const cartQuantityInput = document.querySelectorAll(
  ".cart-item-quantity-input"
);
// console.log(cartIcon);
// console.log(cartCount);
const createCartItem = async (item, formattedPrice) => {
  const section = document.createElement("section");
  section.classList.add("cart-item");
  section.setAttribute("id", item.variant_id);
  section.innerHTML = `
            <div class="loading-state-container">
                <div class="cart-item-loader">
                    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                </div>
                <button type="button" id="${
                  item.variant_id
                }" class="cart-item-deleteBtn">remove</button>
            </div>
            <div class="cart-item-img-container">
            <img src="${item.image}" alt="${item.product_title}">
            </div>
            <ul class="cart-item-details">
            <li class="cart-item-details-sections">
                <span class="cart-item-title">${item.product_title}</span>
                <div>${formattedPrice}</div>
            </li>
            <li class="cart-item-details-sections">
                <span>Quantity</span>
                <div class="cart-item-quantity-selection-container">
                <button type='button' class="cart-item-quantity-action-btn decrementBtn">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <rect width="10" height="10" fill="url(#pattern0_4961_402)"/>
                    <defs>
                    <pattern id="pattern0_4961_402" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlink:href="#image0_4961_402" transform="scale(0.0078125)"/>
                    </pattern>
                    <image id="image0_4961_402" width="128" height="128" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAADdgAAA3YBfdWCzAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAHMSURBVHic7d2xbVRRFEXRM6YEMjqgBUvuy5K7oBGKQCJwH6YL+xF4RELuQey1pJtMdKW357/RT+Zyzhldd7degNsSQJwA4gQQJ4A4AcQJIE4AcQKIE0CcAOIEECeAOAHECSBOAHECiBNAnADiBBAngDgBxAkgTgBxAogTQJwA4gQQJ4A4AcQJIE4AcQKIE0CcAOIEECeAOAHECSBOAHECiBNAnADiBBAngDgBxAkgTgBxAogTQJwA4gQQJ4A4AcQJIE4AcQKIE0DdOWfXv4+93/Z928u2Y/7Lebme8f2fc78e/uO2139gQfMx87rt8Zyzy96/+T/mOqh52/bwadu3bV9vvAwf77Lt82Xv98KXGy/Dbfzy2I+72/Z86yW4mWc/Arvetj3cnXN+bnu6fkDD27anc85PL4Ja89eLoMv18Ily78cJIE4AcQKIE0CcAOIEECeAOAHECSBOAHECiBNAnADiBBAngDgBxAkgTgBxAogTQJwA4gQQJ4A4AcQJIE4AcQKIE0CcAOIEECeAOAHECSBOAHECiBNAnADiBBAngDgBxAkgTgBxAogTQJwA4gQQJ4A4AcQJIE4AcQKIE0CcAOIEECeAOAHECSDuNxDcptIo5Q7LAAAAAElFTkSuQmCC"/>
                    </defs>
                    </svg>
                </button>
                <input value="${
                  item.quantity
                }" class="cart-item-quantity-input" readonly type="text" name="quantity" id="quantity">
                <button type='button' class="cart-item-quantity-action-btn incrementBtn">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <rect width="10" height="10" fill="url(#pattern0_4961_401)"/>
                        <defs>
                        <pattern id="pattern0_4961_401" patternContentUnits="objectBoundingBox" width="1" height="1">
                        <use xlink:href="#image0_4961_401" transform="scale(0.0078125)"/>
                        </pattern>
                        <image id="image0_4961_401" width="128" height="128" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAADdgAAA3YBfdWCzAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAJdSURBVHic7d0xahtBGEfx/6ccIV1ukAuoEOhYAoHqQEBdLpJDBFToHvYtvF8KjxOwiawi1op97wfTrKeY1TztGjVT3R2aqtok2SVZj0vnJMfuPs23qnkULYCq2if5lmT16k9TkkN3f7/9quaDCmB883/l7ea/mJJsSU+Cf30QS7XL5XtejTkYtADW70+5as5i0F4BV91sd9dHr+Ve0J4AesUA4AwAzgDgDADOAOAMAM4A4AwAzgDgDADOAOAMAM4A4AwAzgDgDADOAOAMAM4A4AwAzgDgDADOAOAMAM4A4AwAzgDgDADOAOAMAM4A4AwAzgDgDADOAOAMAM4A4AwAzgDgDADOAOAMAM4A4AwAzgDgDADOAOAMAM4A4AwAzgDgDICuuzNODtsk+ZnkIUk7Fjkexh5v/uz72Px9kqc7WKDjNuMpyb67U3n+5l86TlXLNCXZfkryI8nXmRej26sknyvP74UvMy9G83j0sQ+3SnKeexGazdl/ArmmJNtVd5+SHMYFMUxJDt198ocg1njzQ1CNzUeoqqtutrvro9dyL3zvwxkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcDRAnj8T3MWgxbANcfkoo7SpQVwzOUTUqcxBwMVwDvH5P49ThUEdXLoi6raJNklWY9L5yRH2uYnyW9Ad+UGuurWJwAAAABJRU5ErkJggg=="/>
                        </defs>
                        </svg>
                </button>
                </div>
            </li>

            ${item.options_with_values
              .map((option) => {
                if (option.name === "Color") {
                  return `
                    <li class="cart-item-details-sections">
                    <span>${option.name}</span>
                    <div>
                        <span style="background-color: ${option.value};" class="cart-item-color"></span>
                    </div>
                    </li>
                `;
                } else {
                  return `
                    <li class="cart-item-details-sections">
                    <span>${option.name}</span>
                    <div>
                        <p>${option.value}</p>
                    </div>
                    </li>
                `;
                }
              })
              .join("")}
            </ul>
`;
  return section;
};
const handleCart = (cart) => {
  if (cart.item_count === 0) {
    cartItems.innerHTML = `
        <div class="cart-item-empty-cart-box">
          <h5>Your cart is empty. <a href="{{ shop.url }}">Return to Shop</a> </h5>
        </div>
    `;
    return;
  }
  cart.items.forEach(async (item) => {
    const formattedPrice = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: cart.currency,
      minimumFractionDigits: 0,
    }).format(item.original_line_price / 100);
    const cartItem = await createCartItem(item, formattedPrice);
    cartItems.innerHTML = "";
    cartItems.appendChild(cartItem);
    // console.log(cartItem);
  });
};

// function to get cart

const getCart = async () => {
  try {
    const response = await fetch(window.Shopify.routes.root + `cart.js`);
    const cart = await response.json();
    // console.log(cart);
    cartIcon.setAttribute("data-cart-number", cart.item_count);
    const countEl = document.querySelector('.cart-drawer-count');
    if (countEl) {
      countEl.textContent = cart.item_count !== 0 ? String(cart.item_count) : '';
    }
    return cart;
  } catch (error) {
    console.log(error.message);
  }
};

// function to remove cart item

const removeCartItem = async (id) => {
  try {
    const response = await fetch(
      window.Shopify.routes.root + `cart/change.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          quantity: 0,
        }),
      }
    );
    const cart = await response.json();
    cartIcon.setAttribute("data-cart-number", cart.item_count);
    if (cart.item_count !== 0) {
      document.querySelector(".cart-drawer-count").textContent =
        cart.item_count;
    } else {
      document.querySelector(".cart-drawer-count").textContent = "";
    }
    // console.log(cart);
    return cart;
  } catch (error) {
    console.log(error.message);
  }
};

// function to update cart item quantity

const handleCartQuantityChange = async (id, quantity) => {
  try {
    const response = await fetch(
      window.Shopify.routes.root + `cart/change.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          quantity: quantity,
        }),
      }
    );

    if (!response.ok) {
      return null;
    }
    const cart = await response.json();
    cartIcon.setAttribute("data-cart-number", cart.item_count);
    if (cart.item_count !== 0) {
      document.querySelector(".cart-drawer-count").textContent =
        cart.item_count;
    } else {
      document.querySelector(".cart-drawer-count").textContent = "";
    }
    // console.log(cart);
    // handleCart(cart);
    return cart;
  } catch (error) {
    console.log(error.message);
  }
};

// function to update cart drawer

async function updateCartDrawer() {
  const res = await fetch(
    window.Shopify.routes.root + "?section_id=unruly-cart-drawer"
  );
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = newBox;
  addCartEventListener();
}
// function to add cart event listener
const addCartEventListener = () => {
  const closeCartBtn = document.querySelector(".close-cart-btn");
  const cartIncrementBtn = document.querySelectorAll(".cart-incrementBtn");
  const cartDecrementBtn = document.querySelectorAll(".cart-decrementBtn");

  const deleteCartBtn = document.querySelectorAll(".cart-item-deleteBtn");
  const loading = document.querySelector(".cart-item-loader");

  closeCartBtn.addEventListener("click", (event) => {
    event.stopPropagation();
    if (event.currentTarget.classList.contains("close-cart-btn")) {
      cartContainer.classList.remove("SlideIn");
      cartOverlay.classList.remove("show_blur");
      cartContainer.classList.add("SlideOut");
      document.getElementsByTagName("body")[0].style.overflow = "auto";
    }
  });
  cartIncrementBtn.forEach((btn) => {
    btn.addEventListener("click", async (event) => {
      event.stopPropagation();
      if (event.currentTarget.classList.contains("cart-incrementBtn")) {
        const cart_item_quantity_container = event.currentTarget.parentElement;
        // console.log(cart_item_quantity_container);
        const cartItem =
          cart_item_quantity_container.parentElement.parentElement
            .parentElement;
        // console.log(cartItem);
        const id = cartItem.getAttribute("id");
        const quantityInput = event.currentTarget.parentElement.querySelector(
          ".cart-item-quantity-input"
        );
        const quantity = parseInt(quantityInput.value);
        if (quantity >= 1) {
          const cart = await handleCartQuantityChange(id, quantity + 1);
          if (cart) {
            quantityInput.value = quantity + 1;
            updateCartDrawer();
          }
        }
      }
    });
  });
  cartDecrementBtn.forEach((btn) => {
    btn.addEventListener("click", async (event) => {
      event.stopPropagation();
      if (event.currentTarget.classList.contains("cart-decrementBtn")) {
        const cart_item_quantity_container = event.currentTarget.parentElement;
        // console.log(cart_item_quantity_container);
        const cartItem =
          cart_item_quantity_container.parentElement.parentElement
            .parentElement;
        // console.log(cartItem);
        const id = cartItem.getAttribute("id");
        // console.log(id);

        const quantityInput = event.currentTarget.parentElement.querySelector(
          ".cart-item-quantity-input"
        );
        const quantity = parseInt(quantityInput.value);
        if (quantity > 1) {
          const cart = await handleCartQuantityChange(id, quantity - 1);
          if (cart) {
            quantityInput.value = quantity - 1;
            updateCartDrawer();
          }
        }
      }
    });
  });
  deleteCartBtn.forEach((btn) => {
    btn.addEventListener("click", async (event) => {
      // console.log(event);
      event.stopPropagation();
      if (event.currentTarget.classList.contains("cart-item-deleteBtn")) {
        const id = event.currentTarget.getAttribute("id");
        event.currentTarget.previousElementSibling.classList.add(
          "state-loading"
        );
        // console.log(id);
        event.target.Next;
        try {
          const response = await removeCartItem(id);
          const cart = response;
          loading.classList.remove("state-loading");
          // handleCart(cart);
          updateCartDrawer();
          // console.log("clicked");
        } catch (error) {
          console.log(error.message);
        }
      }
    });
  });
};

addCartEventListener();
